import { QueryClient } from '@tanstack/react-query';
import { DEFAULT_RETRY_COUNT, DEFAULT_RETRY_INTERVAL } from '../assets/constants/index.tsx';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: DEFAULT_RETRY_COUNT,
      refetchInterval:
      // false,
      DEFAULT_RETRY_INTERVAL,
    },
  },
});
